import React, { useCallback } from 'react'
import bluebird from 'bluebird'
import Page from 'components/layout/Page'
import Button from '@material-ui/core/Button'
import { useSelector, useDispatch } from 'react-redux'
import authSelectors from 'store/selectors/auth'
import authActions from 'store/modules/auth'

const Login = ({

}) => {
 
  const dispatch = useDispatch()
  const embedded = useSelector(authSelectors.embedded)

  // we can't do google oauth in an iframe so
  // open a window that can do the oauth loop
  // keep checking to see if we have a succesful login
  // if yes - then redirect to the original URL
  // embeddedAutoCloseAfterLogin tells the opened auth window to close once it has done
  // because we are using cookie auth - we don't need any cross-window communication
  const onLogin = useCallback(async () => {
    if(embedded) {
      const redirectUrl = localStorage.getItem('initialURL')
      localStorage.removeItem('initialURL')
      localStorage.setItem('embeddedAutoCloseAfterLogin', 'yes')
      window.open('/api/v1/auth/google')
      let user = null
      while(!user || !user.id) {
        await bluebird.delay(1000)
        user = await dispatch(authActions.authenticateRaw())
      }
      document.location = redirectUrl
    }
    else {
      document.location = '/api/v1/auth/google'
    }
  }, [
    embedded,
  ])

  return (
    <Page>
      <Button
        variant="contained"
        color="primary"
        onClick={ onLogin }
      >
        Login with Google
      </Button>
    </Page>
  )
}

export default Login